import React           from 'react';
import OpenHours       from 'pursuit/components/Widgets/OpenHours';
import Newsletter      from 'pursuit/components/Widgets/Newsletter';

export default function PageFooter(props) {
    const { isMenuOpen } = props;

    const className = isMenuOpen ? ' menu-open' : '';

    return (
        <section className={`page-footer major-padding--top--bottom${className}`}>
            <div className="grid-center footer-content content-maxWidth">
                <div className="col-5_xs-11_sm-11 first">
                    <OpenHours />
                </div>
                <div className="col-5_xs-11_sm-11 last">
                    <Newsletter />
                </div>
            </div>
        </section>
    );
};
